export class RecordLock{

    static lockId:any = {};

}


// WEBPACK FOOTER //
// ./src/app/domain/CanDeactivateTeam.ts